<main class="session-layout">

  <!-- Panel decorativo (solo desktop) -->
  <div class="session-brand-panel d-none d-lg-flex flex-column align-items-center justify-content-center text-white text-center p-5">
    <i class="pi pi-wrench mb-4" style="font-size: 4rem;"></i>
    <h1 class="fw-bold mb-2">Los Angeles</h1>
    <p class="mb-0 opacity-75" style="font-size: 1.1rem;">Consola de administración</p>
    <p class="opacity-50 mt-2" style="font-size: 0.85rem;">Gestión integral para tu taller mecánico</p>
  </div>

  <!-- Panel del formulario -->
  <div class="session-form-panel d-flex align-items-center justify-content-center p-4">
    <div class="session-form-container w-100">
      <router-outlet></router-outlet>
    </div>
  </div>

</main>
